import {Theme} from '@material-ui/core/styles';
import {WithStyles} from '@material-ui/core/styles/withStyles';
import createStyles from '@material-ui/core/styles/createStyles';

export const styles = (theme: Theme) => createStyles({});

export type Styles = WithStyles<typeof styles>;
